export const COMPARISON_VALUE_GRID_CARD_COUNT = 4;

export const COMPARISON_VALUE_GRID_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'comparison-value-grid-layout',
  PLACEHOLDER_HEADING: 'Section Heading',
  PLACEHOLDER_CARD_TITLE: 'Card Title',
  PLACEHOLDER_CARD_DESCRIPTION: 'Card description text',
  DEFAULT_ALT_CARD_ICON: 'Value card icon',
  DEFAULT_ALT_BACKGROUND_IMAGE: 'Section background'
} as const;
